import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './App.tsx'
import { Gate } from './components/Gate.tsx'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'

// Outside the Gate on purpose: a throw in the sign-in screen itself would otherwise be the blank
// page nobody can get past.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <Gate>
        <App />
      </Gate>
    </ErrorBoundary>
  </StrictMode>,
)
